export default __webpack_public_path__ + "static/logo_3-88271fe57989360a157a7155f993b79b.jpg";